import type { CurvePath, SceneControl, Vector3 } from '@anov/3d-core'
import ObjectLayer from '../Base/ObjectLayer'
import { createOffsetPath } from './utils'

type RealismTrafficParams = {
  path: CurvePath<Vector3>
  width?: number
  divide?: number
  corner?: number
}

export class BaseTraffic extends ObjectLayer {
  /** 路面宽度 */
  protected _width: number

  /** 车道线数量 */
  protected _divide: number

  protected _path: CurvePath<Vector3>

  protected _corner = 10

  /** 车道线 */
  public lanelines: CurvePath<Vector3>[] = []

  constructor(params: RealismTrafficParams, sceneControl: SceneControl) {
    super(sceneControl)

    const { path, width = 2, divide = 1, corner = 10 } = params

    this._path = path
    this._width = width
    this._divide = divide
    this._corner = corner

    this.generateLaneLines()
  }

  protected get baseLine() {
    return createOffsetPath(this._path, -this._width / 2, 0)
  }

  protected generateLaneLines() {
    this.lanelines = []

    for (let i = 0; i < this._divide; i++) {
      const offset = this._width / this._divide
      const line = createOffsetPath(this.baseLine, offset * (i + 1), this._corner)

      this.lanelines.push(line)
    }
  }
}